export const environment = {
    production: false,
    isExternal: true,
    msalConfig: {
        auth: {
            clientId: '5e13e4f8-316d-44f2-8d89-12c57bf9a2d3',
            authority: ""
        },
    },
    apiConfig: {
        scopes: ['openid profile offline_access 5e13e4f8-316d-44f2-8d89-12c57bf9a2d3'],
        uri: 'https://pplfirststage.onmicrosoft.com/5e13e4f8-316d-44f2-8d89-12c57bf9a2d3/app.user',
    },
    b2cPolicies: {
        names: {
            signUpSignIn: 'B2C_1A_SIGNUP_SIGNIN',
            mfa: 'B2C_1A_STEPUP_MFA'
        },
        authorities: {
            signUpSignIn: {
                authority:
                    'https://pplfirststage.b2clogin.com/pplfirststage.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN',
            },
            mfa: {
                authority: 'https://pplfirststage.b2clogin.com/pplfirststage.onmicrosoft.com/B2C_1A_STEPUP_MFA'
            }
        },
        authorityDomain: 'pplfirststage.b2clogin.com',
    },
    apiUrl: 'https://ngenapiext-stg.pplfirst.com/external',
    mobileHealthUrl: 'https://www.mobilehealth.com/ny-cdpap-ppl-medical-screenings/',
    wotcUrl: 'https://sandbox.wotc.com/portal/public-partnerships-llc-sandbox/f8850?noStartDate=1',
    apimSubScriptionKey: '017f684c947a445281f09c2a9b121285',
    restrictedMenus: ["process_codes", "service_codes", "participant_provider_rates", "authorizations", "timesheets"],
    mfaTimeOutSeconds: 600
};